import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setBreadcrumbs, setCreateButton, setSearchHandler, setTitle} from "../actions/main";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import {DepartmentService} from "../services/DepartmentService";
import NavFilter from "../components/NavFilter";

function Department() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [data, setData] = useState(false)
    let navigation = useNavigate();

    const navOptions = [
        {
            label: 'Общая информация',
            count: null,
            query: ''
        },
        // {
        //     label: 'Франшиза',
        //     count: null,
        //     query: 'franchise'
        // },
        {
            label: 'Предметы',
            count: null,
            query: 'additional'
        },
        {
            label: 'Группы/классы',
            count: null,
        query:  'groups'
        }
    ]

    const [tab, setTab] = useState('')
    const [isNew, setIsNew] = useState(false)

    const updateData = () => {
        DepartmentService.get(locationParams.departmentId, 'additionals,groups').then((res) => {
            setData({...res, ...{updateData: updateData, setActiveTab: setTab}})
            dispatch(setTitle(res.name))
        })
    }

    useEffect(() => {
        dispatch(setTitle(''))
        dispatch(setCreateButton(false))
        dispatch(setSearchHandler(false))
        if (locationParams.departmentId === 'create') {
            setIsNew(true)
        } else {
            setIsNew(false)
            updateData()
        }

    }, [currentDepartment, locationParams.departmentId]);

    return (
        <>
            <div className="card project-list">
                <div className="row align-items-center">
                    <div className="col overflow-auto">
                        <NavFilter hideAll={true} options={navOptions} handleClick={(e) => {
                           navigation('/departments/' + locationParams.departmentId + '/' + e)
                            setTab(e)

                        }} active={tab}/>
                    </div>
                </div>
            </div>


                {data || isNew ? <Outlet context={data ? data : isNew}/> : ''}

        </>
    )
}

export default Department